import './index.scss';
import { Dropdown, Menu } from '@umu/umu-design';
import { IMenuItemInfo } from '@umu/umu-design/es/components/Menu/interface';
import React, { useEffect, useState } from 'react';

interface IProps {
    list: IMenuItemInfo[];
    overlayNode?: React.ReactNode;
    children: JSX.Element | React.ReactNode;
    className?: string;
    trigger?: 'click' | 'hover';
    onChange?: (value: string) => void;
    onLayoutCallback?: (data: { onVisibleChange: (visible: boolean) => void }) => void;
}

export const MenuDrop = (props: IProps) => {
    const { list = [], className = '', trigger = 'hover', overlayNode, onChange } = props;
    const [visible, setVisible] = useState<boolean>(false);
    const onVisibleChange = (visible: boolean) => {
        setVisible(visible);
    };
    const onMenuChange = (value: { key: string }) => {
        onChange?.(value.key);
        setVisible(false);
    };
    useEffect(() => {
        props?.onLayoutCallback?.({ onVisibleChange });
        return () => {
            setVisible(false);
        };
    }, []);
    return (
        <Dropdown
            overlay={overlayNode ? <div className={`${className} overlay-node`}>{overlayNode}</div> : <Menu list={list} className={className} itemClassName={`custom-menu-drop-item ${className}-item`} onClick={onMenuChange} />}
            visible={visible}
            trigger={[trigger]}
            onVisibleChange={onVisibleChange}
        >
            <div className={`${className}-child ${className}-child-${visible ? 'active' : ''}`}>{props.children}</div>
        </Dropdown>
    );
};
